module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bar-container"
  }, [(_vm.currentPage !== 0) ? _c('span', {
    staticClass: "p color-orange"
  }, [_vm._v("Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.allPages) + " ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96e8a1e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/pageBar.vue
// module id = 650
// module chunks = 1